import { useMemo } from 'react';

import useCurrentState from '../../hooks/dialog/useCurrentState';

import { CreateToastOptions } from './Toast.types';
import { useToastContext } from './ToastContext';

export function useToast() {
  const toastConfig = useToastContext();
  const [, , toastConfigRef] = useCurrentState(toastConfig);

  return useMemo(() => {
    const toast = (options: CreateToastOptions) => {
      return toastConfigRef.current?.addToast(options);
    };

    toast.close = toastConfigRef.current.close;

    return toast;
  }, [toastConfigRef]);
}
